








import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'saveBtnGroup'
})
export default class extends Vue {
  @Prop({ default: 'common.cancel' }) public cancelText!: string;
  @Prop({ default: 'common.save' }) public saveText!: string;
  // loading
  public loading: boolean = false;
  public disabled: boolean = false;

  public save() {
    this.$emit('submit-form');
  }

  public cancel() {
    this.$emit('cancel-form');
  }
  public disabledTrue() {
    this.disabled = true;
  }
  public disabledFalse() {
    this.disabled = false;
  }
  // loading为true
  public loadingTrue() {
    this.loading = true;
  }
  // loading为false
  public loadingFalse() {
    this.loading = false;
  }
}
